import { render } from "./CarCheckListPage.vue?vue&type=template&id=66745911"
import script from "./CarCheckListPage.vue?vue&type=script&lang=js"
export * from "./CarCheckListPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__